import { getListCore } from "../../../api/services/axiosCore.service";

/**
 * Fetches a list of shipping services.
 * @returns {Promise<Array>} A promise resolving to an array of shipping services.
 */
export const getShippingServices = () => {
  const params = { per_page: 200 };

  return getListCore("/shipping_services", params).then((res) => res.results);
};
